module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("j4WHq"))).then(() => parcelRequire('aZjf9'));